module.exports = __webpack_public_path__ + "static/media/condair_logo.3eba2984.svg";